const SvgIconMessenger = () => (
  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <circle fill="#0084FF" fillRule="nonzero" cx="50" cy="50" r="50" />
    <path
      d="M50 21c-16.569 0-30 12.23-30 27.313 0 8.597 4.363 16.267 11.181 21.273V80l10.213-5.512A32.753 32.753 0 0 0 50 75.63c16.569 0 30-12.23 30-27.317C80 33.23 66.569 21 50 21zm2.58 37l-7.653-7.958L30 58l16.42-17 7.838 7.958L69 41 52.58 58z"
      fill="#FFF"
    />
  </svg>
)

export default SvgIconMessenger
